export const environment = {
    production: false,
    apiBaseUrl: 'https://template.backend.gravityigm-dev.com/api/v1', // replace with your dev API URL or use a proxy
    auth0: {
        domain: "cleargov-auth.us.auth0.com",
        clientId: "YP3uNaVtORpzCYftCHltE2WD5J4UN12l",
        audience: "https://cleargov-auth.us.auth0.com/api/v2/",
        redirectUri: "https://admin.template.gravityigm-dev.com"
    },
};
